"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageTargetsResponseToJSON = exports.LanguageTargetsResponseFromJSONTyped = exports.LanguageTargetsResponseFromJSON = exports.instanceOfLanguageTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var TargetBase_1 = require("./TargetBase");
/**
 * Check if a given object implements the LanguageTargetsResponse interface.
 */
function instanceOfLanguageTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfLanguageTargetsResponse = instanceOfLanguageTargetsResponse;
function LanguageTargetsResponseFromJSON(json) {
    return LanguageTargetsResponseFromJSONTyped(json, false);
}
exports.LanguageTargetsResponseFromJSON = LanguageTargetsResponseFromJSON;
function LanguageTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'languages': !(0, runtime_1.exists)(json, 'languages') ? undefined : (json['languages'].map(TargetBase_1.TargetBaseFromJSON)),
    };
}
exports.LanguageTargetsResponseFromJSONTyped = LanguageTargetsResponseFromJSONTyped;
function LanguageTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'languages': value.languages === undefined ? undefined : (value.languages.map(TargetBase_1.TargetBaseToJSON)),
    };
}
exports.LanguageTargetsResponseToJSON = LanguageTargetsResponseToJSON;
